// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul li a[data-v-2663566a] {\n  color: #333333;\n}\nlabel[data-v-2663566a] {\n  font-weight: normal;\n}\n.tip-label[data-v-2663566a] {\n  color: #4a4a4a;\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
